import React, { useContext } from "react";
import { ThemeContext } from "../../ThemedContext/Provider";

import { Title, Content, Amount, Plans, Wrapper, Container, Row, Col } from "./style";

const contents = [
  {
    title: "BASIC PLAN",
    amount: '2,000',
    lists: [
      "3 Song Uploads",
      "2 Song Promotions",
      "2 Days Artist Bio promotion",
      "1 Featured promotion",
    ],
  },
  {
    title: "PREMIUM PLAN",
    amount: '4,000',
    lists: [
      "3 Song Uploads",
      "2 Song Promotions",
      "2 Days Artist Bio promotion",
      "1 Featured promotion",
    ],
  },
  {
    title: "ADVANCE PLAN",
    amount: '6,000',
    lists: [
      "3 Song Uploads",
      "2 Song Promotions",
      "2 Days Artist Bio promotion",
      "1 Featured promotion",
    ],
  },
];

const FirstAdvert = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper>
      <Container>
        <Row>
          {contents.map((content, idx) => (
            <Col key={idx} themed={theme}>
              <Title>{content.title}</Title>
              <Content>
                <Amount>
                  <span>&#8358;</span>
                  <h1>{content.amount}</h1>
                </Amount>
                <Plans>
                  {content.lists.map((list, i) => (
                    <h3 key={i}>{list}</h3>
                  ))}
                </Plans>
              </Content>
            </Col>
          ))}
        </Row>
      </Container>
    </Wrapper>
  );
};

export default FirstAdvert;
